import { Collapse } from "@mantine/core"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { SwishSpinner } from "react-spinners-kit"
import BackgroundJobNotificationImg from "../assets/background_job_notification.jpg"

export const BackgroundJobBanner = () => {
	const { t } = useTranslation()
	const [opened, setOpened] = useState(false)

	return (
		<div
			className="border shadow"
			style={{
				marginTop: "1rem",
				marginBottom: "1rem",
				background: "#ccffb3",
				padding: "1rem 1rem",
				paddingBottom: "0.5rem",
				borderRadius: "1rem",
			}}
		>
			<div
				style={{
					display: "flex",
					gap: "1rem",
					alignItems: "center",
					justifyContent: "start",
				}}
			>
				<SwishSpinner
					size={20}
					frontColor="#215108"
					backColor="#2e6b0d"
				/>

				<p
					style={{
						fontSize: "0.85rem",
						fontWeight: "500",
						color: "#215108",
						lineHeight: "1.1",
					}}
				>
					{t("single.fetching_product_in_background")}
				</p>
			</div>

			<p
				style={{
					textAlign: "right",
					color: "#215108",
					fontSize: "0.65rem",
					textDecoration: "underline",
					cursor: "pointer",
				}}
				onClick={() => setOpened((prev) => !prev)}
			>
				{opened ? t("common.hide") : t("common.read_more")}
			</p>

			<Collapse in={opened}>
				<p
					style={{
						fontSize: "0.85rem",
						fontWeight: "500",
						color: "#215108",
						lineHeight: "1.1",
						marginTop: "1rem",
						marginBottom: "1rem",
					}}
				>
					{t("single.some_products_may_take_a_while")}
				</p>
				<p
					style={{
						fontSize: "0.85rem",
						fontWeight: "500",
						color: "#215108",
						lineHeight: "1.1",
						marginBottom: "1rem",
					}}
				>
					{t("single.when_your_product_is_ready_to_be_imported")}
				</p>
				<div style={{ display: "flex", justifyContent: "center" }}>
					<img
						src={BackgroundJobNotificationImg}
						className="shadow border"
						style={{ height: "5rem", borderRadius: "1rem" }}
					></img>
				</div>
			</Collapse>
		</div>
	)
}
